import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GenerateAttendanceSessionCSVRequest {
  sessionId: string;
  showBalance: boolean;
}

export interface GenerateAttendanceSessionCSVResponse {
  success: boolean;
  jobId: string;
  message: string;
}

export const generateAttendanceSessionCSVAPI = async (
  params: GenerateAttendanceSessionCSVRequest,
) => {
  const response = await baseAPI.post<GenerateAttendanceSessionCSVResponse>(
    `/attendance/generate-session-csv`,
    params,
  );
  return response.data;
};

// Note: queryOptions is not needed for mutations, only for queries

export const useGenerateAttendanceSessionCSV = () => {
  return useMutation({
    mutationFn: generateAttendanceSessionCSVAPI,
    mutationKey: [KEYS.ATTENDANCE_SESSION_CSV_JOBS, 'generate'],
  });
};
